import { Controller } from "@hotwired/stimulus"

// Copies bid/prebid datetimes from the first visible contract row onto the add
// link before Turbo requests new nested fields (replaces legacy field.js clone).
export default class extends Controller {
  static values = {
    baseUrl: String,
    listId: { type: String, default: "job_contracts_list" },
  }

  prepareUrl(event) {
    const list = document.getElementById(this.listIdValue)
    if (!list) return

    const firstLine = list.querySelector('[data-nested-line-list-target="line"]:not([hidden])')
    if (!firstLine) return

    const url = new URL(this.baseUrlValue, window.location.origin)
    const bidInput = firstLine.querySelector('input[name*="[bid_datetime]"]')
    const prebidInput = firstLine.querySelector('input[name*="[prebid_datetime]"]')

    if (bidInput?.value) url.searchParams.set("bid_datetime", bidInput.value)
    if (prebidInput?.value) url.searchParams.set("prebid_datetime", prebidInput.value)

    event.currentTarget.href = `${url.pathname}${url.search}`
  }
}
